import {atcStates} from '../atc-routes';

export default function AtcCheckController(
    $rootScope,
    $scope,
    $state,
    $location,
    $window,
    $timeout,
    authService,
    atcFlightsService,
    atcApiService,
    l10nService,
    localeService,
    localStorageService,
) {
        'ngInject';
        const vm = this;
        const LAST_ATC_CHECK_CONDITIONS = 'last_atc_check_conditions';
        const LAST_ATC_CHECK_LANG = 'last_atc_check_lang';

        Object.assign(vm, {
            $onInit,
            checkEligibility,
        });

        $scope.model = {
            pnr: '',
            trip: null,
            department: null,
            apikey: null,

            unauthorizedAgent: false,
            missingApiKey: false,
            failedApiKeyCheck: false,

            missingPnr: false,
        };
        $scope.checkEligibillity = checkEligibility;

        function $onInit() {
            setLanguageSettings();
            setParamsFromUrlOrCached();
            authorizationProcedure();
        }

        function setLanguageSettings() {
            const lang = localStorageService.get(LAST_ATC_CHECK_LANG) || localeService.getCurrentCulture();
            l10nService.getAllTranslations(lang);
        }

        function authorizationProcedure() {

            if (authService.isLoggedIn()) {
                onAuthSuccess();
                return;
            }

            const cachedApiKey = authService.getCachedAgentApiKey();
            if (!$scope.model.apikey && cachedApiKey && !authService.isTokenExpired()) {
                onAuthSuccess();
                return;
            }

            if (!$scope.model.apikey) {
                setApiKeyFlags(true, true, false);
                return;
            }

            atcApiService.checkAgentApiKey({apikey: $scope.model.apikey}).then(
                function({data}) {
                    if (!data.IsError) {
                        onAuthSuccess(data.Message || $scope.model.apikey);
                        return;
                    }
                    onAuthFail();
                },
                onAuthFail
            );
        }

        function onAuthSuccess(key) {
            setApiKeyFlags(false, false, false);
            if (key) {
                authService.setAuthorizedAgent(key);
            }
        }

        function onAuthFail() {
            setApiKeyFlags(true, false, true);
            authService.cleanAuthorizedAgent();
            //$window.location.replace(appCONST.logoutUrl);
        }

        function setParamsFromUrlOrCached() {
            const urlparams = $location.search();
            let fromUrl = false;
            const props = ['pnr', 'trip', 'department', 'apikey'];
            props.forEach((param) => {
                if (urlparams[param]) {
                    fromUrl = true;
                    $scope.model[param] = urlparams[param];
                }
            });

            if (fromUrl) {
                localStorageService.set(LAST_ATC_CHECK_CONDITIONS, $scope.model);
                return;
            }

            const lastCheckConditions = localStorageService.get(LAST_ATC_CHECK_CONDITIONS);
            if (lastCheckConditions && !authService.isTokenExpired()) {
                props.forEach((param) => {
                    if (lastCheckConditions[param]) {
                        $scope.model[param] = lastCheckConditions[param];
                    }
                });
            }
        }

        function setApiKeyFlags(unauthorizedAgent, missingApiKey, failedApiKeyCheck) {
            $scope.model.unauthorizedAgent = unauthorizedAgent;
            $scope.model.missingApiKey = missingApiKey;
            $scope.model.failedApiKeyCheck = failedApiKeyCheck;
        }

        function checkEligibility() {
            if (!$scope.model.pnr) {
                const pnrCtrl = $window.document.getElementById('pnr');
                pnrCtrl.focus();
                $scope.model.missingPnr = true;
                $timeout(() => $scope.model.missingPnr = false, 8000);
                return;
            }
            atcFlightsService.cleanCheckResultRequest();
            $state.go(atcStates.CHECK_RESULT, {
                pnr: $scope.model.pnr,
                trip: $scope.model.trip,
                department: $scope.model.department,
                fromTripDetails: false,
            });
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcCheckController.js